var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',_vm._b({staticClass:"py-4 px-6 text-sm font-medium bg-white border-b-8 border-gray-100 whitespace-no-wrap"},'th',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }